import React from "react"

interface Brand {
  brand_id: string
  count: number
  brandName?: string
}

interface SelectedTransition {
  from: string
  to: string
  brands: Brand[]
  date: string
}

interface BrandDetailsModalProps {
  isOpen: boolean
  selectedTransition: SelectedTransition | null
  onClose: () => void
  getStateDisplayName: (state: string) => string
}

const BrandDetailsModal: React.FC<BrandDetailsModalProps> = ({
  isOpen,
  selectedTransition,
  onClose,
  getStateDisplayName,
}) => {
  if (!isOpen || !selectedTransition) {
    return null
  }

  const formatDate = (dateString: string) => {
    if (Number.isNaN(Date.parse(dateString))) {
      return dateString
    }
    if (dateString.includes(" - ")) {
      return dateString
        .split(" - ")
        .map((date) => {
          const parsedDate = new Date(date)
          return parsedDate.toISOString().split("T")[0]
        })
        .join(" - ")
    }
    return new Date(dateString).toISOString().split("T")[0]
  }

  return (
    <div className="fixed inset-y-0 right-0 w-96 bg-white shadow-xl border-l border-gray-200 z-50 flex flex-col">
      <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white p-6 flex-shrink-0">
        <div className="flex items-center justify-between">
          <h3 className="text-xl font-semibold">Marka Detayları</h3>
          <button onClick={onClose} className="text-white hover:text-gray-200 transition-colors">
            <span className="text-2xl">×</span>
          </button>
        </div>
        <div className="mt-2 text-blue-100">
          <p>
            <span className="font-medium">Durum Değişimi:</span>{" "}
            {getStateDisplayName(selectedTransition.from)} →{" "}
            {getStateDisplayName(selectedTransition.to)}
          </p>
          <p>
            <span className="font-medium">Tarih:</span> {formatDate(selectedTransition.date)}
          </p>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto p-6 min-h-0">
        <div className="mb-4">
          <h4 className="text-lg font-semibold text-gray-900 mb-3">
            Markalar ({selectedTransition.brands.length})
          </h4>
          <div className="space-y-3">
            {selectedTransition.brands.map((brand, index) => (
              <div key={brand.brand_id}>
                <a
                  className="cursor-pointer gap-2"
                  href={`/brands/find/${brand.brand_id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg border border-gray-200">
                    <div className="flex items-center space-x-3">
                      <div className="bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-semibold">
                        {index + 1}
                      </div>
                      <div>
                        <p className="font-medium text-gray-900">
                          {brand.brandName || brand.brand_id}
                        </p>
                        <p className="text-sm text-gray-500">{brand.count} başvuru</p>
                      </div>
                    </div>
                    <div className="text-right">
                      <span className="text-2xl font-bold text-blue-600">
                        {brand.count.toLocaleString()}
                      </span>
                    </div>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="bg-gray-50 px-6 py-4 border-t border-gray-200 flex-shrink-0">
        <div className="flex justify-between items-center">
          <div className="text-sm text-gray-600">
            Toplam:{" "}
            {selectedTransition.brands
              .reduce((sum, brand) => sum + brand.count, 0)
              .toLocaleString()}{" "}
            başvuru
          </div>
          <button
            onClick={onClose}
            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors"
          >
            Kapat
          </button>
        </div>
      </div>
    </div>
  )
}

export default BrandDetailsModal
